import Vue from 'vue';
export const scormEventBus = new Vue();